import { atom } from "recoil";

// 임시
const routeState = atom<string>({
    key: "routeState",
    default: localStorage.getItem("___route") || "",
    effects: [
        ({ onSet }) => {
            onSet((n, o: any) => {
                localStorage.setItem("___route", n);
            });
        },
    ],
});

export default routeState;
